import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RequiresPermissionsModule } from '../../directives/requires-permissions/requires-permissions.module';
import { RiderHasBalanceDialogComponent } from './rider-has-balance-dialog.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, MatListModule, RequiresPermissionsModule],
  exports: [RiderHasBalanceDialogComponent],
  declarations: [RiderHasBalanceDialogComponent]
})
export class RiderHasBalanceDialogModule {}
